import * as React from 'react'
import Icon1 from '../../../assets/images/how-to-win/icono1.svg'
import Icon2 from '../../../assets/images/how-to-win/icono2.svg'
import Icon3 from '../../../assets/images/how-to-win/icono3.svg'
import Icon4 from '../../../assets/images/how-to-win/icono4.svg'
import Icon5 from '../../../assets/images/how-to-win/icono5.svg'
import Icon6 from '../../../assets/images/how-to-win/icono6.svg'
import Icon7 from '../../../assets/images/how-to-win/icono7.svg'
import Icon8 from '../../../assets/images/how-to-win/icono8.svg'
/*images Ecuador*/
import Icon2ec from '../../../assets/images/how-to-win/icono2ec.svg'
import Icon5ec from '../../../assets/images/how-to-win/icono5ec.svg'
import Icon6ec from '../../../assets/images/how-to-win/icono6ec.svg'

export const Instructions = process.env.LOCALE === "es-EC" ? 
[
  {
    image: Icon1,
    description: (
      <>
        <b>¡No olvides guardar tus empaques!</b> Recuerda que al final de la actividad, los debes entregar para recibir tu premio.
      </>
    ),
  },
  {
    image: Icon2ec,
    description: (
      <>
        <b>¡Esto es muy importante!</b> Tendremos 2 etapas: si ganas en alguna de las etapas, tus claves ya no tendrán validez, si pierdes, seguirás concursando con las claves que tengas.
      </>
    ),
  },
  {
    image: Icon3,
    description: (
      <>
        <b>Es MUY importante</b> que tengas presente que las claves que hayas ingresado en Tus Puntos de NosotrasOnline, no tendrán validez para que participes en esta actividad
      </>
    ),
  },
  {
    image: Icon7,
    description: (
      <>
        <b>¡Serán 2 etapas!:</b> Etapa 1: 1 ganadora de Iphone XR y 4 ganadoras de 6 meses de productos Nosotras, etapa 2: 1 ganadora de Iphone 13 y 4 ganadoras de 6 meses de productos Nosotras.
      </>
    ),
  },
  {
    image: Icon5ec,
    description: (
      <>
        <b>Para participar, debes tener entre 9 y 17 años</b>  y estar estudiando en el colegio. Al final, debes presentar un certificado escolar para validar esta información.
      </>
    ),
  },
  {
    image: Icon6ec,
    description: (
      <>
        <b>Tendremos un top por cada etapa,</b> ¡así que alístate!
      </>
    ),
  },
]
: process.env.LOCALE === "es-PE" ?
[
  {
    image: Icon1,
    description: (
      <>
        <b>¡No olvides guardar tus empaques!</b> Recuerda que al final de la
        actividad, tanto para tu participación individual como para la de tu
        colegio, los debes entregar para recibir tu premio.
      </>
    ),
  },
  {
    image: Icon3,
    description: (
      <>
        <b>Es MUY importante</b> que tengas presente que las claves que hayas ingresado en Tus Puntos de NosotrasOnline, no tendrán validez para que participes en esta actividad.
      </>
    ),
  },
  {
    image: Icon2,
    description: (
      <>
        <b>Podrás participar por los premios individuales y por el premio mayor</b> (si te registraste con un colegio).
      </>
    ),
  },
  {
    image: Icon5ec,
    description: (
      <>
        <b>Para participar, debes tener entre 9 y 17 años</b> y estar estudiando en el colegio. Al final, debes presentar un certificado escolar para validar esta información.
      </>
    ),
  },
  {
    image: Icon6,
    description: (
      <>
        <b>Ten en cuenta</b> que puedes participar por los premios individuales y esas mismas claves le suman a tu colegio si lo tienes inscrito.
      </>
    ),
  },
  {
    image: Icon6ec,
    description: (
      <>
        <b>Tendremos un top de manera individual y un top general para el premio mayor,</b> ¡así que alístate!
      </>
    ),
  },
]
:
[
  {
    image: Icon1,
    description: (
      <>
        <b>¡No olvides guardar tus empaques!</b> Recuerda que al final de la
        actividad, tanto para tu participación individual como para la de tu
        colegio, los debes entregar para recibir tu premio.
      </>
    ),
  },
  {
    image: Icon5,
    description: (
      <>
        <b>¡Esto es muy importante!</b> Tendremos 4 etapas: si ganas en alguna
        de las etapas, tus claves personales ya no tendrán validez, si pierdes,
        seguirás concursando con las claves que tengas.
      </>
    ),
  },
  {
    image: Icon2,
    description: (
      <>
        <b>Ten en cuenta</b> que puedes participar por los premios individuales
        de cada etapa y esas mismas claves personales le suman a tu colegio si
        lo tienes inscrito.
      </>
    ),
  },
  {
    image: Icon6,
    description: (
      <>
        <b>Cada etapa tendrá</b> 1 ganadora de Iphone 13 y 4 ganadoras de 6
        meses de productos Nosotras. En la etapa final, premiaremos al colegio
        que más claves haya registrado durante todas las etapas. ¡Corre a
        participar!
      </>
    ),
  },
  {
    image: Icon3,
    description: (
      <>
        <b>Es MUY importante</b> que tengas presente que las claves personales
        que hayas ingresado en Tus Puntos de NosotrasOnline, no tendrán validez
        para que participes en esta actividad.
      </>
    ),
  },
  {
    image: Icon7,
    description: (
      <>
        <b>Serán 4 etapas:</b>
        <p>Etapa 1: va del 15 marzo al 15 de mayo del 2022</p>
        <p>Etapa 2: va del 16 de mayo al 15 de julio del 2022</p>
        <p>Etapa 3: va del 16 de julio al 31 de agosto del 2022</p>
        <p>
          Etapa 4: colegio ganador. (La fecha de finalización será la misma de
          la etapa 3)
        </p>
      </>
    ),
  },
  {
    image: Icon4,
    description: (
      <>
        <b>Para participar, debes tener entre 9 y 19 años</b> y estar estudiando
        en el colegio. Al final, debes presentar un certificado escolar para
        validar esta información.
      </>
    ),
  },
  {
    image: Icon8,
    description: (
      <>
        <b>Tendremos un top</b> por cada etapa de manera individual y un top
        general para el premio mayor, ¡así que alístate!
      </>
    ),
  },
]

  